import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";

const initialState = {
  smeLeads: [],
  loading: false,
  smeDetailedView: {},
  smeStatus: [],
  smeTopicSchedules: [],
  subjectEnrollId: [],
};

export const getSmeLeads = createAsyncThunk("sme/getsmeleads", async (data) => {
  const res = await apiRequest({
    method: "get",
    url: `crm-leads/sme-leads/?page=${data.page}&limit=${data.limit}&date=${data.date}&filter=${data.filter}`,
  });
  return res;
});
export const getSmeDetailedView = createAsyncThunk(
  "sme/getsmedeatilview",
  async (id) => {
    const res = await apiRequest({
      method: "get",
      url: `crm-leads/assigned?leadId=${id}`,
    });
    return res;
  }
);
export const getSmeCallStatus = createAsyncThunk(
  "sme/getsmecallstatus",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `crm-leads/get-sme-call-status?page=1&limit=no`,
    });
    return res;
  }
);
export const UpdateSmeStatus = createAsyncThunk(
  "sme/updatesmestatus",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: `crm-leads/change-sme-status`,
      data: data,
    });
    return res;
  }
);

// ---------------------------------------------smeschedules---------------------------------------------------------
export const getSmeSchedules = createAsyncThunk(
  "sme/getsmeschedules",
  async ({ page, limit, status, filter, course_enrollment_id }) => {
    const res = await apiRequest({
      method: "get",
      url: `sme-schedule-topic?page=${page}&limit=${limit}&status=${status}&filter=${filter}&course_enrollment_id=${course_enrollment_id}`,
    });
    return res;
  }
);

export const createSmeSchedules = createAsyncThunk(
  "sme/createsmeschedules",
  async (data) => {
    const res = await apiRequest({
      method: "post",
      url: "sme-schedule-topic",
      data: data,
    });
    return res;
  }
);

export const updateSmeSchedules = createAsyncThunk(
  "sme/updatesmeschedules",
  async (data) => {
    const res = await apiRequest({
      method: "put",
      url: "sme-schedule-topic",
      data: data,
    });
    return res;
  }
);

export const getSubjectEnrollmentId = createAsyncThunk(
  "sme/getsubjectenrollid",
  async (leadId) => {
    const res = await apiRequest({
      method: "get",
      url: `general/get-subject-enrollment-id/${leadId}`,
    });
    console.log("Get SEI", res);

    return res;
  }
);

export const deleteTopic = createAsyncThunk("sme/deletetopic", async (id) => {
  const res = await apiRequest({
    method: "delete",
    url: `sme-schedule-topic/${id}`,
  });
  return res;
});

const smeSlice = createSlice({
  name: "sme",
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSmeLeads.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSmeLeads.fulfilled, (state, action) => {
      state.loading = false;
      state.smeLeads = action.payload;
    });
    builder.addCase(getSmeDetailedView.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSmeDetailedView.fulfilled, (state, action) => {
      state.loading = false;
      state.smeDetailedView = action.payload.data;
    });
    // ---------------------------------smestatus-------------------------------
    builder.addCase(UpdateSmeStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(UpdateSmeStatus.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(UpdateSmeStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    // ---------------------------------------smecallstatus--------------------------
    builder.addCase(getSmeCallStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSmeCallStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.smeStatus = action.payload.data;
    });
    // -----------------------------smeschedules--------------------------
    builder.addCase(getSmeSchedules.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSmeSchedules.fulfilled, (state, action) => {
      state.loading = false;
      state.smeTopicSchedules = action.payload;
    });
    builder.addCase(createSmeSchedules.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createSmeSchedules.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createSmeSchedules.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(updateSmeSchedules.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateSmeSchedules.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateSmeSchedules.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
    builder.addCase(getSubjectEnrollmentId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSubjectEnrollmentId.fulfilled, (state, action) => {
      state.loading = false;
      state.subjectEnrollId = action.payload;
    });
    builder.addCase(deleteTopic.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteTopic.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

// export const { apiCallData, admissionReg, storeId } = smeSlice.actions;

export default smeSlice.reducer;
